import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import {
    showProjectCostPriorityLoader,
    onSaveProjectCostPriority,
    onProjectCostPriorityClose,
} from 'actions/projectCostPriority';
import { inputFields, displayedImage, showErrors, modalHeader, isFormValid, getFormError } from '../common';

const ProjectCostPriorityEdit = () => {
    const dispatch = useDispatch();
    const editProjectCostPriorityState = useSelector(state => state.projectCostPrioritys.editProjectCostPriorityState);
    const projectCostPriority = useSelector(state => state.projectCostPrioritys.selectedProjectCostPriority);
    const [selectedProjectCostPriority, setSelectedProjectCostPriority] = useState(projectCostPriority);
    const [formErrors, setFormErrors] = useState({ name: '' });
    const [formValid, setFormValid] = useState(false);

    // using selectedProjectCostPriority makes it behave like componentDidUpdate - effect takes place when selectedProjectCostPriority changes
    useEffect(() => {
        setSelectedProjectCostPriority(projectCostPriority);
        setFormValid(false);
        validateForm();
    }, [projectCostPriority]);

    // using selectedProjectCostPriority makes it behave like componentDidUpdate - effect takes place when selectedProjectCostPriority changes
    useEffect(() => {
        setFormValid(false);
        validateForm();
    }, [selectedProjectCostPriority]);

    const handleUserInput = (event, isNumber) => {
        const name = event.target.name;
        let value = event.target.value;
        if (isNumber) {
            value = Number(event.target.value);
        }
        updateSelectedProjectCostPriorityField(name, value);
        validateField(name, value);
    };

    const updateSelectedProjectCostPriorityField = (fieldName, value) => {
        const newProjectCostPriority = { ...projectCostPriority };
        newProjectCostPriority[fieldName] = value;
        setSelectedProjectCostPriority(newProjectCostPriority);
    };

    const validateField = (fieldName, value) => {
        formErrors[fieldName] = getFormError(fieldName, value);
        setFormErrors(formErrors);
        validateForm();
    };

    const validateForm = () => {
        setFormValid(isFormValid(selectedProjectCostPriority));
    };


    const maintainButton = (label) => {
        return (
            <Button className="text-uppercase" disabled={!formValid} color="primary" onClick={() => {
                dispatch(showProjectCostPriorityLoader());
                dispatch(onProjectCostPriorityClose());
                dispatch(onSaveProjectCostPriority(selectedProjectCostPriority));
                setFormValid(false);
            }}>
                {label}
            </Button>
        );
    };

    const modalHeaderOnClick = () => {
        return () => {
            setFormValid(false);
            dispatch(onProjectCostPriorityClose());
        };
    };

    const modalBody = (buttonText) => {
        return (
            <Fragment>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        {displayedImage(selectedProjectCostPriority)}
                        {showErrors(formErrors)}
                        {inputFields(projectCostPriority, handleUserInput)}
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    {maintainButton(buttonText)}
                </div>
            </Fragment>
        );
    };
    
    return (
        <Modal className="modal-box" isOpen={editProjectCostPriorityState}>
            {modalHeader(<IntlMessages id="projectCostPriority.saveProjectCostPriority" />, modalHeaderOnClick)}
            {modalBody(<IntlMessages id="projectCostPriority.saveProjectCostPriority" />)}
        </Modal>
    );
};

export default ProjectCostPriorityEdit;


// WEBPACK FOOTER //
// ./components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js